import { Flowplayer as FlowplayerType } from '@flowplayer/player';
import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { StyleSheet, View } from 'react-native';

import VideoPlayer from '../Video/index';
import { usePlayer } from '../context';
import CTVPlayerWithAds from './ads';
import { CustomControls } from './controls';

import { WebDiv } from 'components/WebDiv';

const CTVPlayer = React.forwardRef<
  CustomPlayerRef,
  CustomPlayerProps & { disableControls?: boolean }
>((props) => {
  const {
    ref: playerRef,
    isPlaying,
    isVisible,
    setIsVisible,
    setShowingAdsCTV,
    isShowingAdsCTV,
    adTagUrl,
  } = usePlayer();
  const [isInitializing, setIsInitializing] = React.useState(true);
  const containerClass = React.useMemo(() => {
    if (isVisible) return 'navigation-container fullscreen';
    return 'navigation-container navigation-ignore navigation-detail-page';
  }, [isVisible]);

  const playerApi = React.useMemo(
    () => playerRef?.current?.getNativePlayerRef() as FlowplayerType.Player,
    [playerRef.current]
  );

  useEffect(() => {
    if (!playerApi) return;
    setIsInitializing(false);
  }, [playerApi]);

  useEffect(() => {
    if (isPlaying) {
      setIsVisible(true);
    }
  }, [isPlaying]);

  useEffect(() => {
    if (!isVisible) playerApi?.pause();
  }, [isVisible, playerApi]);

  useEffect(() => {
    return () => setShowingAdsCTV(true);
  }, []);

  return createPortal(
    <WebDiv className={containerClass}>
      <View style={styles.container}>
        {isShowingAdsCTV && adTagUrl ? (
          <CTVPlayerWithAds {...props} />
        ) : (
          <>
            <VideoPlayer {...props} ref={playerRef} />
            {!isInitializing && <CustomControls api={playerApi} exit={() => setIsVisible(false)} />}
          </>
        )}
      </View>
    </WebDiv>,
    document.querySelector('#root')!
  );
});

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#000',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default CTVPlayer;
